"use client";

import dynamic from "next/dynamic";

// Client-only, matching the established pattern in app/blogs/[slug]/BlogPostClient.tsx.
// `ssr: false` is not allowed inside a Server Component (app/best/[slug]/page.tsx),
// which is why this needs its own small client wrapper - it keeps the entire
// react-markdown/rehype/remark/syntax-highlighter chain (~1MB) out of this
// route's server bundle entirely, deferring it to the browser instead.
const MarkdownRenderer = dynamic(() => import("@/components/blog/MarkdownRenderer"), {
  ssr: false,
  loading: () => (
    <div className="animate-pulse bg-muted/20 h-64 w-full rounded-2xl border border-border" />
  ),
});

export default function MarkdownSection({ content }: { content: string }) {
  return <MarkdownRenderer content={content} />;
}
